module.exports = __webpack_public_path__ + "assets/images/project/icon/type_icon.svg?v=20c333c5";